import React, { useRef, useState } from "react";
import "./AgentResponseComposer.css";

const CANNED_RESPONSES = [
  "Thanks for reaching out! 👋",
  "Let me look into that for you.",
  "Could you share more details?",
  "You're all set!",
];

/**
 * AgentResponseComposer
 * Text composer an agent uses to reply to a visitor.
 *
 * Props:
 *  - onSend(text)
 *  - disabled: boolean (e.g. no conversation selected)
 */
export default function AgentResponseComposer({
  onSend = () => {},
  disabled = false,
}) {
  const [text, setText] = useState("");
  const textareaRef = useRef(null);

  const send = () => {
    const trimmed = text.trim();
    if (!trimmed || disabled) return;
    onSend(trimmed);
    setText("");
    textareaRef.current?.focus();
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      send();
    }
  };

  return (
    <div className="cb-composer">
      <div className="cb-composer-box">
        <button className="cb-composer-icon-btn" title="Attach file" disabled={disabled}>
          📎
        </button>
        <textarea
          ref={textareaRef}
          rows={1}
          placeholder={disabled ? "Select a conversation to reply" : "Type your message…"}
          value={text}
          disabled={disabled}
          onChange={(e) => setText(e.target.value)}
          onKeyDown={handleKeyDown}
        />
        <button className="cb-composer-icon-btn" title="Emoji" disabled={disabled}>
          🙂
        </button>
        <button
          className="cb-composer-send"
          onClick={send}
          disabled={disabled || !text.trim()}
          title="Send"
        >
          ➤
        </button>
      </div>

      <div className="cb-composer-footer">
        <span className="cb-composer-hint">Enter to send · Shift+Enter for new line</span>
        <div className="cb-canned-responses">
          {CANNED_RESPONSES.map((r) => (
            <button
              key={r}
              className="cb-canned-chip"
              disabled={disabled}
              onClick={() => setText((t) => (t ? `${t} ${r}` : r))}
            >
              {r}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
